import React from 'react';
import { Table, Space, Tag, Typography, Button, Empty, Grid } from 'antd';
import ColumnsCardList from '../common/ColumnsCardList';
import { 
  EditOutlined, 
  DeleteOutlined, 
  PhoneOutlined, 
  MailOutlined, 
  CheckCircleOutlined, 
  CloseCircleOutlined 
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Text } = Typography;

const DeliveryPersonList = ({ deliveryPersons, onDelete }) => {
  // Mobile (< md) : cartes à la place du tableau ; `=== false` évite un flash avant la mesure
  const screens = Grid.useBreakpoint();
  const isMobile = screens.md === false;
  // Colonnes responsive pour la table des livreurs
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'name',
      key: 'name',
      width: 120,
      render: (text) => <Text strong className="text-xs sm:text-sm">{text}</Text>,
    },
    {
      title: 'Contact',
      key: 'contact',
      width: 160,
      // Masquer sur mobile très petit
      responsive: ['sm'],
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Space>
            <PhoneOutlined className="text-xs" />
            <Text className="text-xs sm:text-sm">{record.phone}</Text>
          </Space>
          {record.email && (
            <Space>
              <MailOutlined className="text-xs" />
              <Text className="text-xs sm:text-sm">{record.email}</Text>
            </Space>
          )}
        </Space>
      ),
    },
    {
      title: 'Véhicule',
      key: 'vehicle',
      width: 140,
      // Masquer sur tablette et plus petit
      responsive: ['md'],
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Text className="text-xs sm:text-sm">{record.vehicle_description || '-'}</Text>
          {record.vehicle_plate && (
            <Text type="secondary" className="text-xs">{record.vehicle_plate}</Text>
          )}
        </Space>
      ),
    },
    {
      title: 'Statut',
      key: 'status',
      width: 80,
      render: (_, record) => (
        <Tag 
          icon={record.is_active ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
          color={record.is_active ? 'success' : 'default'}
          size={window.innerWidth < 768 ? 'small' : 'default'}
          className="text-xs"
        >
          {record.is_active ? 'Actif' : 'Inactif'}
        </Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 80,
      align: 'center',
      render: (_, record) => (
        <Space size="small">
          <Link to={`/app/delivery-persons/${record.id}`}>
            <Button
              type="link"
              icon={<EditOutlined />}
              size={window.innerWidth < 768 ? "small" : "middle"}
              title="Modifier"
            />
          </Link>
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(record)}
            size={window.innerWidth < 768 ? "small" : "middle"}
            title="Supprimer"
          />
        </Space>
      ),
    },
  ];

  if (deliveryPersons.length === 0) {
    return <Empty description="Aucun livreur trouvé" />;
  }

  if (isMobile) {
    // Nom en haut de carte, coordonnées/véhicule/statut au milieu, modifier/supprimer en bas
    return (
      <ColumnsCardList
        columns={columns}
        dataSource={deliveryPersons}
        headerKeys={['name']}
        clientPageSize={10}
        emptyText="Aucun livreur trouvé"
      />
    );
  }

  return (
    <Table
      columns={columns}
      dataSource={deliveryPersons.map(person => ({ ...person, key: person.id }))}
      pagination={{ 
        pageSize: 10,
        showSizeChanger: window.innerWidth > 768,
        showQuickJumper: window.innerWidth > 768,
        showTotal: (total, range) => 
          window.innerWidth > 768 
            ? `${range[0]}-${range[1]} sur ${total} livreurs`
            : `${total} livreurs`
      }}
      scroll={{ 
        x: 'max-content',
        scrollToFirstRowOnChange: true 
      }}
      size={window.innerWidth < 768 ? 'small' : 'middle'}
    />
  );
};

export default DeliveryPersonList; 